import { supportsObjectFitCover } from 'helpers/device'
import { useDisplayBrowserState } from 'helpers/hooks/useDisplayBrowserState'
import React, { FC, ImgHTMLAttributes } from 'react'
import styled, { css } from 'styled-components'

interface IFallbackContainer {
  backgroundSrc: string
}

interface IImage {
  src: string
  alt?: string
}

const Image = styled.img<Partial<IImage>>`
  object-fit: cover;
  object-position: top;
  height: 100%;
  width: 100%;
  vertical-align: bottom;
`

const FallbackContainer = styled.div<Partial<IFallbackContainer>>`
  height: 100%;
  width: 100%;
  background-position: top;
  background-size: cover;
  background-repeat: no-repeat;
  ${({ backgroundSrc }) =>
    backgroundSrc &&
    css`
      background-image: url(${backgroundSrc});
    `};
`

const FallbackImage = styled.img<Partial<IImage>>`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  vertical-align: bottom;
`

export const FittedImage: FC<ImgHTMLAttributes<{}>> = props => {
  const { src, alt, className, height, width } = props
  const isBrowser = useDisplayBrowserState()
  if (isBrowser && !supportsObjectFitCover) {
    return (
      <FallbackContainer backgroundSrc={src}>
        <FallbackImage
          data-testid="FallbackImage"
          alt={alt}
          src={src}
          height={height}
          width={width}
        />
      </FallbackContainer>
    )
  }
  return (
    <Image
      data-testid="Image"
      src={src}
      alt={alt}
      className={className}
      height={height}
      width={width}
    />
  )
}
